import { Pipe, PipeTransform } from '@angular/core';
import {VizixService} from "../../providers/vizix.service";

/**
 * Generated class for the ValidateUpcPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'validateUpc',
})
export class ValidateUpcPipe implements PipeTransform {
  constructor(private vizixService: VizixService){
  }
  transform(value: string) {
    let regExp = new RegExp(this.vizixService.configurationApp.AppParametersConfiguration.UPCValidation.value);
    if(!this.vizixService.configurationApp.AppParametersConfiguration.DisableUPCCheck.value){
      return regExp.test(value) ? value : "";
    } else {
      return value;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/validate-tag/validate-upc.ts